import React from "react";
import "./Projects.css";
import proj1img from "../../Assets/proj1logo.jpeg";
import { Button, Space } from "antd";
import proj2img from "../../Assets/proj2img.png";

const data = [
  {
    img: proj1img,
    title: "Campus Kart",
    discrip:
      "Aimed at improving the demand-supply chain within our college through an interactive e-commerce platform.",
    link: "https://campus-kart.vercel.app/",
  },
  {
    img: proj2img,
    title: "Code Vila",
    discrip:
      " Devised an interactive, multilingual (C, C++, Java) code editor, utilizing React.js, HTML5, CSS, andJavascript.",
    link: "https://codevila.vercel.app/",
  },
];

export default function Projects() {
  return (
    <div className="project">
      <h1 className="projectHead">Key Projects </h1>
      <br />
      <div className="pcarddiv">
        {data &&
          data.map((d) => (
            <div className="pcard">
              <div className="imgdiv">
                <img className="projimg" src={d.img} alt="" />
              </div>
              <h2 style={{ color: "white" }}> {d.title} </h2>
              <p className="description">{d.discrip}</p>
              <Button href={d.link}>View</Button>
            </div>
          ))}
      </div>
    </div>
  );
}
